import $ from "jQuery";
import { Loader } from "@googlemaps/js-api-loader";

let geocoder;
let map;
let autocomplete;
let profileEl = $(".profile-section");
let quill;
const loader = new Loader({
    apiKey: 'AIzaSyDcrKy0_Xl4vw4R0gBMxfAxmQBH6XdtoEc',
    version: 'weekly',
    libraries: ['places', 'geometry'],
});

$(function () {
  if (profileEl.length > 0) {
    loader.load().then(() => {
      autocomplete = new google.maps.places.AutocompleteService();
      geocoder = new google.maps.Geocoder();
    });
    addRequiredClasses($("#frm-contact"));
    cleanUrl();

    $(".quillEditor").each(function (i, e) {
      let el = $(this),
        id = "quilleditor-" + i,
        val = el.val(),
        editor_height = 200;
      let div = $("<div/>")
        .attr("id", id)
        .css("height", editor_height + "px")
        .html(val);
      el.addClass("d-none");
      el.parent().append(div);

      quill = new Quill("#" + id, {
        modules: {
          toolbar: [
            ["bold", "italic", "underline", { script: "super" }],
            [{ list: "ordered" }, { list: "bullet" }],
          ],
        },
        theme: "snow",
        placeholder: "Zadejte stručný popis Vašich služeb...",
      });

      quillUpdateCharCounter();

      quill.on("text-change", function () {
        el.html(quill.root.innerHTML);
        if (quill.getLength() > 500) {
          quill.deleteText(500, quill.getLength());
        }
        quillUpdateCharCounter();
      });

      $(".profile-tab").on("keydown", "#" + id, function (e) {
        let allowedKeys = [8, 37, 38, 39, 40, 46];
        if (quill.getLength() > 500 && allowedKeys.indexOf(e.keyCode) === -1) {
          e.preventDefault();
          e.stopPropagation();
        }
      });
    });
  }

  let count = $(".extra-address").length;

  $(".confirmation-btn").on("click", function () {
    if ($(".confirmation-wrapper").first().hasClass("none")) {
      $(".confirmation-popup").css("display", "flex").hide().fadeIn(500);
    } else {
      $("#frm-submission-chckbx_confirm").prop("checked", true);
      $("#frm-submission-chckbx_confirm_sending").prop("checked", true);
      $("#frm-submission").submit();
    }
  });

  $(".confirmation-popup .screen-darken").on("click", function () {
    $(".confirmation-popup").fadeOut(500);
  });

  $(".profile-tab-item").on("click", function () {
    const id = $(this).attr("id");
    $(".profile-tab-item").removeClass("active");
    $(".profile-tab").removeClass("current");
    $(this).addClass("active");
    $("#" + id + "-form").addClass("current");
  });

  $(".profile-tab").on("click", ".rm-address", function () {
    $(this).closest(".extra-address").remove();
  });

  $(".profile-tab").on("click", ".screen-darken", function () {
    $(".screen-darken, .gmap-popup").fadeOut(500);
  });

  $(".profile-tab").on("click", ".gmap-check-btn", function () {
    const parent = $(this).closest(".profile-section");
    parent.find(".screen-darken, .gmap-popup").fadeIn(500);
    let addressNumber = "";
    if (parent.hasClass("extra-address")) {
      addressNumber = "_" + parseInt(parent.attr("id").split("-").pop());
    }
    parent
      .find(".gmap-check-btn")
      .removeClass("accepted")
      .html("ZKONTROLOVAT POLOHU");
    parent.find(".gmap-check > input").val(0);
    const zip = parent.find("#frm-contact-zip" + addressNumber).val();
    const region = parent.find("#frm-contact-region" + addressNumber).val();
    const city = parent.find("#frm-contact-city" + addressNumber).val();
    const street = parent.find("#frm-contact-street" + addressNumber).val();
    const streetNumber = parent
      .find("#frm-contact-street_number" + addressNumber)
      .val();
    const orientationalNumber = parent
      .find("#frm-contact-orientational_number" + addressNumber)
      .val();
    const address = [
      street,
      streetNumber,
      streetNumber ? "" : orientationalNumber,
      zip,
      city,
      region,
    ].join(" ");
    map = new google.maps.Map($(this).parent().find(".gmap-location")[0], {
      zoom: 6,
      center: { lat: 49.8175, lng: 15.473 },
    });
    autocomplete.getPlacePredictions(
      {
        input: address,
        componentRestrictions: { country: "CZ" },
      },
      function (predictions, status) {
        if (
          status != google.maps.places.PlacesServiceStatus.OK ||
          !predictions
        ) {
          parent
            .find(".gmap-address")
            .addClass("not-found")
            .html("Adresa nenalezena. Zkontrolujte prosím zadané údaje");
          parent
            .find(".gmap-accept")
            .addClass("disabled")
            .css("pointer-events", "none");
          return;
        }
        parent
          .find(".gmap-accept")
          .removeClass("disabled")
          .css("pointer-events", "all");
        const predicted = predictions[0];
        parent
          .find(".gmap-address")
          .removeClass("not-found")
          .html(
            "<strong>Nalezená adresa:</strong>&nbsp;" + predicted.description
          );
        geocoder.geocode({ placeId: predicted.place_id }, (results, status) => {
          if (status === "OK") {
            if (results[0]) {
              map.setZoom(15);
              map.setCenter(results[0].geometry.location);
              const marker = new google.maps.Marker({
                map,
                position: results[0].geometry.location,
              });
              parent
                .find("input[name=lat" + addressNumber + "]")
                .val(results[0].geometry.location.lat());
              parent
                .find("input[name=lng" + addressNumber + "]")
                .val(results[0].geometry.location.lng());
            } else {
              parent
                .find(".gmap-address")
                .addClass("not-found")
                .html("Adresa nenalezena. Zkontrolujte prosím zadané údaje");
            }
          } else {
            parent
              .find(".gmap-address")
              .addClass("not-found")
              .html("Adresa nenalezena. Zkontrolujte prosím zadané údaje");
          }
        });
      }
    );
  });

  $(".profile-tab").on(
    "change",
    ".profile-section input[required]",
    function () {
      let parent = $(this).closest(".profile-section");
      parent
        .find(".gmap-check-btn")
        .removeClass("accepted")
        .html("ZKONTROLOVAT POLOHU");
      parent.find(".gmap-check > input").val(0);
    }
  );

  $(".profile-tab").on("click", ".gmap-accept", function () {
    let parent = $(this).closest(".profile-section");
    parent
      .find(".gmap-check-btn")
      .addClass("accepted")
      .html("POLOHA ZKONTROLOVÁNA");
    parent.find(".gmap-check > input").val(1);
    parent.find(".screen-darken, .gmap-popup").fadeOut(500);
  });

  $(".profile-tab").on("click", ".gmap-reject", function () {
    let parent = $(this).closest(".profile-section");
    parent
      .find(".gmap-check-btn")
      .removeClass("accepted")
      .html("ZKONTROLOVAT POLOHU");
    parent.find(".gmap-check > input").val(0);
    parent.find(".screen-darken, .gmap-popup").fadeOut(500);
  });

  $("#add-address").on("click", function () {
    count++;
    getExtraAddressHtml(count).then((response) => {
      $("#extra-addresses").append(response.html);
    });
  });

  $(".profile-tab").on(
    "keyup",
    ".extra-address input[required], #main-address input[required]",
    function () {
      const parent = $(this).closest(".profile-section");
      const reg = /^[1-7]([0-9] *){4}$/;
      if (
        !$(this).val() ||
        ($(this).attr("name").indexOf("zip") > -1 && !reg.test($(this).val()))
      ) {
        $(this).addClass("invalid");
        parent.find(".gmap-check, .gmap-check-btn").addClass("disabled");
      } else {
        $(this).removeClass("invalid");
        let complete = true;
        parent.find("input[required]").each(function (key, input) {
          if (
            !$(input).val() ||
            ($(input).attr("name").indexOf("zip") > -1 &&
              !reg.test($(input).val()))
          ) {
            complete = false;
          }
        });
        if (complete) {
          parent.find(".gmap-check, .gmap-check-btn").removeClass("disabled");
        }
      }
    }
  );

  $(".profile-tab").on("click", "#delete-profile", function (e) {
    e.preventDefault();
    if (
      confirm(
        "Opravdu si přejete smazat svůj profil i s veškerými údaji ze stránky a Seznamu specialistů?"
      )
    ) {
      window.location = $(this).attr("href");
    }
  });
});

const getExtraAddressHtml = async (count) => {
  try {
    const response = await fetch(
      SITE_PARAMS.site_url + `/wp-json/nzu/v1/specialistExtraAddress/html`,
      {
        method: "POST",
        headers: new Headers({
          "Content-Type": "application/json",
        }),
        body: JSON.stringify(count),
      }
    );
    const result = await response.json();
    console.log(result);
    return result;
  } catch (e) {
    console.log(e);
    return null;
  }
};

const quillUpdateCharCounter = () => {
  $(".tinymce-char-counter strong").text(501 - quill.getLength());
};

const addRequiredClasses = (e) => {
  e.find("input:required").each(function (key, el) {
    let label = $(el).parent().parent().children().get(0);
    $(label).addClass("required");
  });
};

const cleanUrl = () => {
  const current = window.location.href;
  const clean = current.split("?")[0];
  window.history.replaceState(null, null, clean);
};
